import {Head} from "@inertiajs/react";
import gradeyPixellated from "../../assets/images/gradey-pixellated-animation.webp";
import ChatWidget from "../ChatWidget.tsx";

type HeroBlockProps = {
  aiModel: string
}

export default function HeroBlock({aiModel}: HeroBlockProps) {
  return (
    <>
      <Head>
        <link rel="preload" as="image" href={gradeyPixellated} fetchPriority="high"/>
      </Head>
      <div className="min-h-screen px-4 pt-28 pb-12 sm:px-6 lg:px-8">
        <div className="mx-auto grid min-h-[calc(100vh-10rem)] max-w-7xl items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(420px,500px)]">
          <section className="max-w-3xl">
            <div className="mb-8 flex items-center gap-4">
              <div className="h-20 w-20 shrink-0 overflow-hidden rounded-sm border-2 border-gray-950 bg-white shadow-[5px_5px_0_rgb(17_24_39)] sm:h-24 sm:w-24">
                <img
                  src={gradeyPixellated}
                  alt="Gradey Cullins"
                  className="h-full w-full object-cover"
                  loading="eager"
                  fetchPriority="high"
                  width="128"
                  height="128"
                />
              </div>
              <div>
                <p className="text-xs font-black uppercase tracking-[0.24em] text-gray-600">
                  AI boosted developer
                </p>
              </div>
            </div>
          </section>

          <aside className="w-full justify-self-center lg:justify-self-end">
            <ChatWidget
              agent="website"
              placeholder="Ask about services, skills, or experience..."
              greeting="Hey, I can answer questions about my AI work, technical background, and the kinds of problems I can help with."
              panelTitle="My personal AI helper"
              panelDescription="This AI is trained on personal information about my skills, career, and experience so you can ask more specific questions."
              panelKicker="Website assistant"
              aiModel={aiModel}
              starterPrompts={[
                "What AI integrations can you build for my SaaS?",
                "How would you approach adding AI to an existing app?",
                "What kinds of projects are you best suited for?",
              ]}
            />
          </aside>
        </div>
      </div>
    </>
  )
}
